import React from 'react';
import Loadable from 'Jsx/Shared/Loadable';
import Loader from 'crehana-ui/Loader';

const RappiSection = () => {
  return (
    <Loadable
      module={() => import(/* webpackChunkName: "checkout-rappi" */ './Rappi')}
      Loader={
        <div className="flex justify-center w-full">
          <Loader size={36} />
        </div>
      }
    />
  );
};

export default RappiSection;
